import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EmailDomainCustomizationDirective } from './directives';
import { EmailDomainCustomizationService } from './services';

@NgModule({
	imports: [CommonModule],
	declarations: [EmailDomainCustomizationDirective],
	providers: [EmailDomainCustomizationService],
	exports: [EmailDomainCustomizationDirective]
})
export class EmailDomainCustomizationModule { }
